import { ArrowRight, ChevronDown, ChevronRight, Info } from "lucide-react";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Assests/css/mybooking.css";
import {
  formatDateStringdot,
  formatDateMMDDYYYY,
} from "../../CommonJquery/CommonJquery";

function BookingCard({ datass, image, key }) {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const openAgreementForm = (event) => {
    event.stopPropagation(); // Prevent card expansion when clicking agreement button
    navigate("/agreement", {
      state: { bookingId: datass.primary_id, carId: datass.car_id },
    });
  };

  const handleNavigate = (event) => {
    event.stopPropagation(); // Prevent card expansion when clicking view details
    console.log("handleNavigate called");
    console.log("datass:", datass);

    if (!datass || !datass.primary_id) {
      console.error("Invalid booking data:", datass);
      return;
    }

    navigate("/trip_details", {
      state: {
        bookingData: datass,
        bookingId: datass.primary_id,
      },
    });
    console.log("Navigation executed!");
  };

  // Check if card should be expandable (only for steps 0, 1, 2, 3, 4)
  const shouldShowExpandable = () => {
    return ["0", "1", "2", "3", "4"].includes(datass.step_for_booking);
  };

  // Get the appropriate message based on status
  const getExpandedMessage = () => {
    switch (datass.step_for_booking) {
      case "0":
        if (datass.mvp_status == "no") {
          return "We’re still waiting for your MVR!\n\nPlease upload your Motor Vehicle Report (MVR)\nto move forward with your booking. Without it, we cannot proceed to insurance review.";
        } else {
          return "Your booking is being processed. We're reviewing your application and documents. You'll receive an update within 24-48 hours.";
        }
      case "1":
        return "Your insurance documents are under review by our team. Once approved, you'll be able to sign the rental agreement and proceed with pickup.";
      case "2":
        if (datass.fill_aggriment_status == 0) {
          return "Great! Your insurance has been approved. Please sign the rental agreement to proceed. After signing, your vehicle will be prepared for pickup.";
        } else {
          return "Excellent! You have successfully signed your rental agreement. Our team is now reviewing the details and preparing your vehicle for pickup. You'll receive a notification and email once everything is ready.";
        }
      case "3":
        return (
          <div>
            <p className="booking-card-expanded-message-text">
              Your car is ready for pickup! Please give us a quick call to
              schedule your pickup time and avoid any delays.
            </p>
            <button
              className="contact-button-booking"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/contact");
              }}
            >
              Contact Us
            </button>
            {/* <p className="booking-card-expanded-message-text">
                Don't forget to bring your valid driving license and ID.
              </p> */}
          </div>
        );
      case "4":
        return "Enjoy your trip! Drive safely and follow all traffic rules. You can contact our support team during business hours if you need any assistance during your rental period.";

      default:
        return "";
    }
  };

  // Toggle card expansion
  const toggleExpansion = () => {
    if (shouldShowExpandable()) {
      setIsExpanded(!isExpanded);
    }
  };

  const [balanceData, setBalanceData] = useState({
    rent: { due: 0, payment: 0 },
    deposit: { due: 0, payment: 0 },
  });

  const handleNavigationDeposit = () => {
    console.log("datass:", datass);
    navigate("/totalDepoitBalance", {
      state: {
        bookingData: datass,
        bookingId: datass.primary_id,
        balanceData: datass,
      },
    }); // path to navigate to
  };
  const handleNavigation = () => {
    console.log("datass:", datass);
    console.log("due_rent1:", datass.due_rent);

    const balanceDatass = {
      rent: {
        due: datass.due_rent,
        due_pay: datass.due_rent,
        payment: datass.due_rent,
      },
      deposit: {
        due: datass.due_deposit,
        due_pay: datass.due_deposit,
        payment: datass.total_deposit,
      },
    };

    navigate("/totalBalance", {
      state: {
        bookingData: datass,
        bookingId: datass.primary_id,
        balanceData: balanceDatass,
        from_where: 2,
      },
    }); // path to navigate to
  };

  return (
    <>
      <div
        className={`booking-card ${isExpanded ? "booking-card-expanded" : ""} ${
          shouldShowExpandable() ? "booking-card-clickable" : ""
        }`}
        key={key}
        onClick={toggleExpansion}
      >
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="d-flex align-items-center flex-grow-1">
            <Link>
              <img
                src={`${image}${datass.image}`}
                alt="Car"
                className="car-image carImageBooking"
              />
            </Link>

            <div className="booking-info">
              <p className="elepsisClassPTop">
                Pickup Date: {formatDateMMDDYYYY(datass.from_date)}
              </p>
              <h3 className="elepsisClass">{datass.car_name}</h3>
              <p className="elepsisClassP">{datass.car_no}</p>
            </div>
          </div>

          <div className="booking-card-right-section">
            {/* Status Buttons */}
            {datass.step_for_booking == 0 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>
                <button className="action-button-booking actioonBtn2 bgPending">
                  Waiting
                </button>
                <div className="approval-section">
                  {datass.mvp_status != "no" && datass.paid_deposit == 0 && (
                    <button
                      className="agreement2-button"
                      onClick={handleNavigationDeposit}
                    >
                      Pay Deposit
                    </button>
                  )}
                </div>
              </div>
            )}
            {datass.step_for_booking == 1 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>
                <button className="action-button-booking actioonBtn2 bgunAprved">
                  Insurance Under Review
                </button>
              </div>
            )}
            {datass.step_for_booking == 2 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>

                {datass.fill_aggriment_status == 0 && (
                  <button className="action-button-booking actioonBtn2 bgAprved">
                    Insurance Approved
                  </button>
                )}
                <div className="approval-section">
                  {datass.fill_aggriment_status == 0 && (
                    <button
                      className="agreement-button"
                      onClick={openAgreementForm}
                    >
                      Sign Agreement
                    </button>
                  )}
                  {datass.fill_aggriment_status == 1 && (
                    <button className="action-button-booking actioonBtn2 bgOn">
                      Agreement Signed
                    </button>
                  )}
                </div>
              </div>
            )}
            {datass.step_for_booking == 3 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>
                <button className="action-button-booking actioonBtn2 bgCompleted">
                  Ready for Pickup
                </button>
                <div className="approval-section">
                  <button
                    className="agreement2-button"
                    onClick={handleNavigation}
                  >
                    Pay
                  </button>
                </div>
              </div>
            )}
            {datass.step_for_booking == 4 && (
              <div className="Mobile-status1">
                {/* <span className="full-text-label"></span> */}
                <button className="action-button-booking actioonBtn2 bgOn">
                  On-Going
                </button>
                <button
                  className="action-button-booking actioonBtn2  DetailBtn"
                  onClick={handleNavigate}
                >
                  View Details <ArrowRight size={17} strokeWidth={1.5} />
                </button>
              </div>
            )}
            {datass.step_for_booking == 10 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>
                <button className="action-button-booking actioonBtn2 bgCancelled">
                  Rejected
                </button>
              </div>
            )}
            {datass.step_for_booking == 9 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>
                <button className="action-button-booking actioonBtn2 bgCancelled">
                  Cancel
                </button>
              </div>
            )}
            {datass.step_for_booking == 5 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>
                <button className="action-button-booking actioonBtn2 bgCompleted">
                  Completed
                </button>
                <button
                  className="action-button-booking actioonBtn2  DetailBtn"
                  onClick={handleNavigate}
                >
                  View Details <ArrowRight size={17} strokeWidth={1.5} />
                </button>
              </div>
            )}
            {datass.step_for_booking == 6 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>
                <button className="action-button-booking actioonBtn2 bgCancelled">
                  Switched
                </button>
                <button
                  className="action-button-booking actioonBtn2  DetailBtn"
                  onClick={handleNavigate}
                >
                  View Details <ArrowRight size={17} strokeWidth={1.5} />
                </button>
              </div>
            )}
            {datass.step_for_booking == 7 && (
              <div className="Mobile-status">
                <span className="full-text-label"></span>
                <button className="action-button-booking actioonBtn2 bgCancelled">
                  Repossesed
                </button>
                <button
                  className="action-button-booking actioonBtn2  DetailBtn"
                  onClick={handleNavigate}
                >
                  View Details <ArrowRight size={17} strokeWidth={1.5} />
                </button>
              </div>
            )}

            {/* Expand/Collapse Icon - Moved inside right section for better mobile layout */}
            {shouldShowExpandable() && (
              <div className="booking-card-expand-icon">
                {isExpanded ? (
                  <ChevronDown size={20} color="#666" />
                ) : (
                  <ChevronRight size={20} color="#666" />
                )}
              </div>
            )}
          </div>
        </div>

        {/* Expandable Content */}
        {isExpanded && shouldShowExpandable() && (
          <div className="booking-card-expanded-content">
            <div className="booking-card-info-header">
              <Info size={16} color="var(--primary-color)" />
              <span className="booking-card-next-step-title">What's Next?</span>
            </div>
            <p className="booking-card-expanded-message">
              {getExpandedMessage()}
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default BookingCard;
